import { render, staticRenderFns } from "./blogTag.vue?vue&type=template&id=d29859ce&scoped=true"
import script from "./blogTag.vue?vue&type=script&lang=js"
export * from "./blogTag.vue?vue&type=script&lang=js"
import style0 from "./blogTag.vue?vue&type=style&index=0&id=d29859ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29859ce",
  null
  
)

export default component.exports